import { PageContext } from "contexts/PageContext";
import { useContext } from "react";

export default function usePage() {
  return useContext(PageContext);
}
